'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PCardBooking = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PCardBooking, _Component);

  function PCardBooking() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PCardBooking);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PCardBooking.__proto__ || (0, _getPrototypeOf2.default)(PCardBooking)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      var styles = require('./PCardBooking.scss');
      event.target.classList.add(styles.noImg);
      event.target.onerror = null;
      event.target.src = '/no-image-voucher.jpg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PCardBooking, [{
    key: 'handle',
    value: function handle() {
      var _props = this.props,
          card = _props.card,
          onChange = _props.onChange;

      if (card && onChange) {
        onChange(card);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PCardBooking.scss');
      var _props2 = this.props,
          _props2$card = _props2.card,
          image = _props2$card.image,
          shop = _props2$card.shop,
          service = _props2$card.service,
          endDate = _props2$card.endDate,
          isValid = _props2$card.isValid,
          className = _props2.className;

      return _react2.default.createElement(
        'div',
        {
          className: styles.PCard + ' ' + className,
          onClick: function onClick() {
            return _this2.handle();
          }
        },
        _react2.default.createElement(
          'div',
          { className: styles.img },
          _react2.default.createElement('img', {
            className: '' + (image ? '' : styles.noImg),
            src: image ? image : '/no-image-voucher.jpg',
            onError: this.onErrorImage
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.boxInfo },
          _react2.default.createElement(
            'div',
            { className: styles.name },
            service.name
          ),
          _react2.default.createElement(
            'div',
            { className: styles.nameShop },
            _react2.default.createElement('img', { src: '/icon/ic_address/ic_address.png', alt: '' }),
            ' ',
            shop.name
          ),
          _react2.default.createElement(
            'div',
            { className: styles.address },
            shop.address
          ),
          _react2.default.createElement(
            'div',
            { className: styles.price },
            _react2.default.createElement(
              'span',
              {
                className: styles.discount + ' ' + (!isValid ? styles.used : '')
              },
              'S\u1EED d\u1EE5ng ngay'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.timeExpire },
            '\u01AFu \u0111\xE3i \u0111\u1EBFn ng\xE0y: ',
            _support.Helper.displayDate(endDate),
            ' ',
            !isValid ? '(Đã sử dụng)' : ''
          )
        )
      );
    }
  }]);
  return PCardBooking;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  isValid: _react.PropTypes.bool,
  card: _react.PropTypes.object,
  onChange: _react.PropTypes.func
}, _temp2);
exports.default = PCardBooking;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/PCardBooking.js
// module id = 1563
// module chunks = 0